export default __webpack_public_path__ + "static/logo7-936b36d4b4027bc1980ef16b137638d2.png";